/**
 * @author caijianjia
 * @date 2020/3/28 10:46 上午
 */

import request from '../config/network/requestUcenterApiService'

// --------------------表单分类开始------------------------------
/**
 * 表单分类管理
 */

// 新建表单分类
export function addFormCategory ({
  type = 'client',
  parentId = 0,
  name,
  description
}) {
  return request({
    url: 'api/courseware/form-category',
    method: 'post',
    data: {
      type,
      parent_id: parentId,
      name,
      description
    }
  })
}

// 删除表单分类
export function deleteFormCategory ({ id, clientsId }) {
  return request({
    url: `api/courseware/form-category/${id}`,
    method: 'delete',
    data: { clients_id: clientsId }
  })
}

// 修改表单分类
export function updateFormCategory ({
  id,
  type = 'client',
  parentId = 0,
  name
}) {
  return request({
    url: `api/courseware/form-category/${id}`,
    method: 'put',
    data: {
      type,
      parent_id: parentId,
      name
    }
  })
}

// 获取表单分类树
export async function getFormCategoryTree () {
  return request({
    url: 'api/courseware/form-category/tree',
    method: 'get'
  })
}

// --------------------表单分类结束------------------------------

/**
 * 表单管理
 */

// 新建表单
export function addForm ({
  categoryId = 0,
  name,
  allowCreate,
  remark,
  options,
  type,
}) {
  return request({
    url: 'api/courseware/form',
    method: 'post',
    data: {
      category_id: categoryId,
      name,
      allow_create: allowCreate,
      remark,
      options,
      type
    }
  })
}

// 删除表单
export function deleteForm ({ id }) {
  return request({
    url: `api/courseware/form/${id}`,
    method: 'delete'
  })
}

// 修改表单
export function updateForm ({
  id,
  categoryId = 0,
  name,
  allowCreate,
  remark,
  options
}) {
  return request({
    url: `api/courseware/form/${id}`,
    method: 'put',
    data: {
      category_id: categoryId,
      name,
      allow_create: allowCreate,
      remark,
      options
    }
  })
}

// 获取表单列表
export function getFormList ({
  page,
  id,
  search,
  categoryId,
  perPage,
  type
}) {
  let url = 'api/courseware/form?'
  if (search) url += `&like[name]=${search}`
  if (type) url += `&equal[type]=${type}`
  return request({
    url,
    method: 'get',
    params: {
      page,
      'equal[category_id]': categoryId,
      'equal[id]': id,
      per_page: perPage
    }
  })
}

// 获取表单详情
export function getFormDetail ({ id }) {
  return request({
    url: `api/courseware/form/${id}`,
    method: 'get'
  })
}

// 复制表单
export function copyForm ({
  id,
  clientsId
}) {
  return request({
    url: `api/courseware/form/copy?clients_id=${clientsId}`,
    method: 'post',
    data: {
      src_id: id
    }
  })
}
